import { ResolveFn } from '@angular/router';
import { ISbStoryData } from '@storyblok/js';
import { map } from 'rxjs';

export const storyblokPageForcedThemeResolver: (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  resolver: any
) => ResolveFn<'light' | 'dark' | undefined> = resolver => route => {
  return resolver(route).pipe(
    map((story: ISbStoryData) => {
      if (!story) return;
      const theme = story.content?.theme;
      return theme || 'light';
    })
  );
};
